import { createUseStyles } from "react-jss";
import { Theme } from "../../../types/Theme";
import * as ChoiceTokens from "../../../theme/choiceThemeTokens";

export default createUseStyles(
    (theme: Theme) => {
        const useModernGridCell = ChoiceTokens.useModernChoiceStyles(theme);

        return {
            checkBox: {
                display: "inline-block",
                userSelect: "none",
                background: "transparent",
            },
            checkBoxGridCell: {
                composes: useModernGridCell
                    ? ["check-box__grid-cell", "check-box__grid-cell--modern"]
                    : "check-box__grid-cell",
                display: "flex",
                height: theme.GridCellMinHeight,
                margin: -theme.GridCellPadding,
                alignItems: "center",
                justifyContent: "center",
                ...(useModernGridCell
                    ? {
                          ...ChoiceTokens.modernGridMatrixCellFocusStyles(theme),
                          "&:hover": {
                              color: theme.PrimaryColor,
                          },
                      }
                    : {
                          "&:hover, &:focus": {
                              color: theme.PrimaryColor,
                          },
                      }),
            },
            checkBoxGridCellChecked: {
                composes: "check-box__grid-cell--checked",
                color: theme.PrimaryColor,
            },
            checkBoxInput: {
                composes: "check-box__input",
                display: "none",
            },
        } as any;
    },
);
